import React from "react";
import { Outlet } from "react-router-dom";
import { StyledEngineProvider } from "@mui/material";
import { AppWrap } from "../../common/commonComps";
import MultiLevelMenu from "./components/MultiLevelMenu";
import { Context } from "../../common/context";
import type { Size, ContextValue } from "../../types";

// const userInfo = { canRedeem: true, isPrimary: true };
// const hasBx = false;

const AccountBase = ({ size }: { size: Size }) => (
    <StyledEngineProvider injectFirst>
        <Context.Consumer>
            {value => (
                <AppWrap style={{ padding: size === `small` ? `` : `0 20px` }} id="appwrap">
                    {size === `large` && <MultiLevelMenu size={size} context={(value as ContextValue).context} />}
                    <Outlet context={[size]} />
                </AppWrap>
            )}
        </Context.Consumer>
    </StyledEngineProvider>
);
export default AccountBase;
